import * as React from 'react';
import createSvgIcon from '@fluentui/react-icons-mdl2/lib/utils/createSvgIcon';

const FluidLogoIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" width="2048" height="2048">
      <path d="M768 1664v128H512q-53 0-99-20t-82-55-55-81-20-100V768h128v768q0 27 10 50t27 40 41 28 50 10h256zm0-1280V256h768q53 0 99 20t82 55 55 81 20 100v256h-128V512q0-27-10-50t-27-40-41-28-50-10H768zm-128 64q0 40-15 75t-41 61-61 41-75 15H192q-40 0-75-15t-61-41-41-61-15-75V192q0-40 15-75t41-61 61-41 75-15h256q40 0 75 15t61 41 41 61 15 75v256zm-512 0q0 26 19 45t45 19h256q26 0 45-19t19-45V192q0-26-19-45t-45-19H192q-26 0-45 19t-19 45v256zm1664 448q53 0 99 20t82 55 55 81 20 100v640q0 53-20 99t-55 82-81 55-100 20h-640q-53 0-99-20t-82-55-55-81-20-100v-640q0-53 20-99t55-82 81-55 100-20h640zm128 896v-640q0-27-10-50t-27-40-41-28-50-10h-640q-27 0-50 10t-40 27-28 41-10 50v640q0 27 10 50t27 40 41 28 50 10h640q27 0 50-10t40-27 28-41 10-50z" />
    </svg>
  ),
  displayName: 'FluidLogoIcon',
});

export default FluidLogoIcon;
